import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { useState } from 'react';
import { decodeColors } from '@/utils/colors';
import { isValidNumber, isValidNumberInputKey } from '@/utils/numbers';
import { getDefaultRanges, MIN_RANGE_LIMIT, MAX_RANGE_LIMIT, validateRange, filterInvalidRanges, sortRanges, appendRange, createRange, getRangeColor } from '@/components/widget/visualizations/GaugeChart/utils';
import Button from '@/components/Button';
import Accordion, { AccordionPanel } from '@/components/Accordion';
import { Input, Label } from '@/components/FormElements';
import ColorPicker from '@/components/Editor/Form/fields/common/ColorPicker';
import RevealPill, { PillChip } from '@/components/Editor/Form/fields/RevealPill';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var TrashIcon = function TrashIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 8V18C7 19.1046 7.89543 20 9 20H15C16.1046 20 17 19.1046 17 18V8H19V18C19 20.2091 17.2091 22 15 22H9C6.79086 22 5 20.2091 5 18V8H7Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 11C9.44772 11 9 11.4477 9 12V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V12C11 11.4477 10.5523 11 10 11Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14 11C13.4477 11 13 11.4477 13 12V16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16V12C15 11.4477 14.5523 11 14 11Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 6V5C8 3.34315 9.34315 2 11 2H13C14.6569 2 16 3.34315 16 5V6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H5C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6H8ZM10 5C10 4.44772 10.4477 4 11 4H13C13.5523 4 14 4.44772 14 5V6H10V5Z",
      fill: "#12131A"
    })]
  }));
};

TrashIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChevronUpCircleIcon = function ChevronUpCircleIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289L15.7071 12.2929C16.0976 12.6834 16.0976 13.3166 15.7071 13.7071C15.3166 14.0976 14.6834 14.0976 14.2929 13.7071L12 11.4142L9.70711 13.7071C9.31658 14.0976 8.68342 14.0976 8.29289 13.7071C7.90237 13.3166 7.90237 12.6834 8.29289 12.2929L11.2929 9.29289Z",
      fill: "#12131A"
    })]
  }));
};

ChevronUpCircleIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChevronDownCircleIcon = function ChevronDownCircleIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.29289 10.2929C8.68342 9.90237 9.31658 9.90237 9.70711 10.2929L12 12.5858L14.2929 10.2929C14.6834 9.90237 15.3166 9.90237 15.7071 10.2929C16.0976 10.6834 16.0976 11.3166 15.7071 11.7071L12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L8.29289 11.7071C7.90237 11.3166 7.90237 10.6834 8.29289 10.2929Z",
      fill: "#12131A"
    })]
  }));
};

ChevronDownCircleIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const WidgetEditFormGaugeChartRanges = _ref => {
  let {
    nameSpace,
    ranges: initialRanges = getDefaultRanges(),
    colorPallet = [],
    openButtonVariant,
    onChange = () => undefined
  } = _ref;
  const {
    0: ranges,
    1: setRanges
  } = useState(initialRanges);
  const {
    0: rangeErrors,
    1: setRangeErrors
  } = useState({});
  const {
    0: activeRangeIndex,
    1: setActiveRangeIndex
  } = useState(null);

  const handleChange = nextRanges => {
    // Validate the ranges
    setRangeErrors(nextRanges.reduce((acc, _, idx) => {
      const validationResult = validateRange(nextRanges[idx], nextRanges[idx - 1], // Previous range
      nextRanges[idx + 1] // Next range
      );

      if (validationResult.errorMessage) {
        acc[idx] = validationResult.errorMessage;
      }

      return acc;
    }, {})); // Update local state

    setRanges(nextRanges); // Filter out invalid ranges

    const filteredRanges = filterInvalidRanges(nextRanges); // Sort the ranges by limit

    onChange(sortRanges(filteredRanges));
  }; // Update the range at the given index


  const handleRangeChange = (range, rangeIndex) => {
    const nextRange = _objectSpread(_objectSpread({}, ranges[rangeIndex]), range); // Do not allow to update a locked range


    if (range.locked) return; // Replace the updated range in the array

    const nextRanges = ranges.slice(0, rangeIndex).concat(nextRange, ranges.slice(rangeIndex + 1));
    handleChange(nextRanges);
  }; // Add a new range


  const addRange = (previousRange, nextRange) => {
    const newRange = createRange({}, previousRange, nextRange);
    const nextRanges = appendRange(ranges, newRange);
    handleChange(nextRanges);
    setActiveRangeIndex(nextRanges.indexOf(newRange));
  }; // Remove a range at the given index


  const removeRange = rangeIndex => {
    const nextRanges = ranges.filter((_, idx) => idx !== rangeIndex);
    handleChange(nextRanges);
  };

  const rangesCount = ranges.length - 1; // Exclude the 0% range

  return /*#__PURE__*/_jsxs(RevealPill, {
    label: "Ranges",
    activeState: /*#__PURE__*/_jsx(PillChip, {
      count: rangesCount
    }),
    openButtonVariant: openButtonVariant,
    children: [/*#__PURE__*/_jsx("p", {
      className: styles.description,
      children: "Customize the colors, labels and range positions of the gauge."
    }), /*#__PURE__*/_jsx(Accordion, {
      children: ranges.map((range, idx) => {
        const isFirst = idx === 0;
        const isLast = idx === rangesCount;
        const namePrefix = `${nameSpace}-${range.limit}-${idx}`;
        const title = `${range.limit}%`;
        const canDelete = !isFirst && !isLast && rangesCount > 1;
        const canChangeColor = !isFirst; // Detect if there is a next possible range to create
        // limit should be between the current range limit and the next range limit

        const nextRange = ranges[idx + 1];
        const nextPossibleRange = createRange({}, range, nextRange);
        const hasNextPossibleRange = Boolean(nextRange) && nextPossibleRange.limit < MAX_RANGE_LIMIT && nextPossibleRange.limit < nextRange.limit && nextPossibleRange.limit > range.limit; // Detect if there is a previous possible range to create
        // limit should be between the previous range limit and the current range limit

        const prevRange = ranges[idx - 1];
        const prevPossibleRange = createRange({}, prevRange, range);
        const hasPrevPossibleRange = Boolean(prevRange) && prevPossibleRange.limit > MIN_RANGE_LIMIT && prevPossibleRange.limit > prevRange.limit && prevPossibleRange.limit < range.limit;
        return /*#__PURE__*/_jsx(AccordionPanel, {
          title: title,
          isOpen: activeRangeIndex === idx,
          onClick: () => setActiveRangeIndex(prev => prev === idx ? null : idx),
          children: /*#__PURE__*/_jsx(RangeFields, {
            nameSpace: namePrefix,
            range: range,
            rangeIndex: idx,
            prevRange: prevRange,
            nextRange: nextRange,
            error: rangeErrors[idx],
            colorPallet: colorPallet,
            isDisabled: range.locked,
            hasColorPicker: canChangeColor,
            hasDelete: canDelete,
            hasPrevPossibleRange: hasPrevPossibleRange,
            hasNextPossibleRange: hasNextPossibleRange,
            onChange: nextRange => handleRangeChange(nextRange, idx),
            onAddRange: addRange,
            onRemoveRange: () => removeRange(idx)
          })
        }, `${namePrefix}-range-item`);
      })
    })]
  });
};

const RangeFields = _ref2 => {
  let {
    nameSpace,
    colorPallet,
    range,
    rangeIndex,
    prevRange,
    nextRange,
    error,
    isDisabled,
    hasDelete,
    hasColorPicker,
    hasPrevPossibleRange,
    hasNextPossibleRange,
    onChange,
    onAddRange,
    onRemoveRange
  } = _ref2;
  const labelFieldId = `${nameSpace}-range-label`;
  const limitFieldId = `${nameSpace}-range-limit`;
  const colorFieldId = `${nameSpace}-range-color`;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!error ? /*#__PURE__*/_jsxs("div", {
      className: styles.actions,
      children: [hasPrevPossibleRange ? /*#__PURE__*/_jsx(AddRangeButton, {
        variant: "up",
        onClick: () => onAddRange(prevRange, range)
      }) : /*#__PURE__*/_jsx(_Fragment, {}), hasNextPossibleRange ? /*#__PURE__*/_jsx(AddRangeButton, {
        variant: "down",
        onClick: () => onAddRange(range, nextRange)
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsxs("div", {
      className: styles.column,
      children: [/*#__PURE__*/_jsx(Label, {
        forInput: limitFieldId,
        className: parentStyles.formField,
        text: "Range stop",
        caption: "Value at which the range stops",
        errorMessage: error,
        children: /*#__PURE__*/_jsx(Input, {
          id: limitFieldId,
          placeholder: "33",
          defaultValue: range.limit,
          type: "number",
          autoFocus: true,
          min: MIN_RANGE_LIMIT,
          max: MAX_RANGE_LIMIT,
          step: 1,
          disabled: isDisabled,
          onKeyDown: e => {
            if (!isValidNumberInputKey(e.key)) {
              e.preventDefault();
            }
          },
          onChange: evt => {
            // Ensure the value is within the range limits
            const value = Math.min(Math.max(parseInt(evt.target.value), MIN_RANGE_LIMIT), MAX_RANGE_LIMIT);
            onChange({
              limit: isValidNumber(value) ? value : 0
            });
          }
        })
      }), /*#__PURE__*/_jsx(Label, {
        forInput: labelFieldId,
        className: parentStyles.formField,
        text: "Range label",
        caption: "Label to display in the gauge chart",
        children: /*#__PURE__*/_jsx(Input, {
          id: labelFieldId,
          placeholder: 'Custom label',
          defaultValue: range.label || '',
          onChange: evt => onChange({
            label: evt.target.value
          })
        })
      }), hasColorPicker ? /*#__PURE__*/_jsx(ColorPicker, {
        id: colorFieldId,
        label: "Fill Color",
        defaultValue: decodeColors(getRangeColor({
          range,
          rangeIndex,
          colorPallet
        })).shift(),
        onChange: color => onChange({
          color: typeof color === 'string' ? color : null
        })
      }, colorFieldId) : /*#__PURE__*/_jsx(_Fragment, {}), hasDelete ? /*#__PURE__*/_jsx(Button, {
        type: "button",
        variant: "delete",
        className: styles.deleteButton,
        leftIcon: /*#__PURE__*/_jsx(TrashIcon, {}),
        onClick: () => onRemoveRange(),
        children: "Delete Range"
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    })]
  });
};

const AddRangeButton = _ref3 => {
  let {
    variant,
    onClick
  } = _ref3;
  return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread(_objectSpread({
    variant: "secondary"
  }, variant === 'up' ? {
    leftIcon: /*#__PURE__*/_jsx(ChevronUpCircleIcon, {})
  } : {}), variant === 'down' ? {
    rightIcon: /*#__PURE__*/_jsx(ChevronDownCircleIcon, {})
  } : {}), {}, {
    onClick: onClick,
    children: "Add Range"
  }));
};

export default WidgetEditFormGaugeChartRanges;